import styled from "styled-components";
import PageTodo from "./client/components/page-todo/page-todo";


function App() {
  return (
    <ContainerApp>
      <PageTodo/>
    </ContainerApp>
  );
}

export default App;

const ContainerApp = styled.div`
`